import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const FinalCTASection = () => (
  <section className="py-24 lg:py-40" data-testid="final-cta-section">
    <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-12 gap-6 items-baseline mb-10">
        <div className="col-span-6">
          <span className="grid-ref">§ 07 / Sign off</span>
        </div>
        <div className="col-span-6 flex justify-end">
          <span className="stamp stamp-ink">Ready when you are</span>
        </div>
      </div>

      <h2 className="h-xl text-[color:var(--ink)] max-w-[1100px]">
        Ready to look as <span className="font-serif-italic text-[color:var(--accent)]">professional</span> as your work?
      </h2>

      <div className="mt-14 grid grid-cols-12 gap-6 items-end border-t border-[color:var(--border)] pt-10">
        <div className="col-span-12 lg:col-span-6">
          <p className="text-[16px] lg:text-[18px] leading-[1.55] text-[color:var(--muted)] max-w-xl">
            Tell us about your trade business and we'll create a free initial website preview — no card, no obligation.
          </p>
        </div>
        <div className="col-span-12 lg:col-span-6 flex flex-col sm:flex-row justify-start lg:justify-end gap-4">
          <a
            href="mailto:contact@readytrades.co.uk"
            className="btn-secondary text-[15px]"
            data-testid="final-cta-secondary"
          >
            Talk to ReadyTrades
          </a>
          <Link to="/get-started" className="btn-primary text-[15px]" data-testid="final-cta-primary">
            Get My Free Preview <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
